import { Download, FileText } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from '@/components/feedback/toast-store'
import { formatBytes } from '@/utils/format'
import type { LmsFile } from '../types'
import { downloadLmsFile } from '../uploads'

/** Downloadable attachments (private files go through the API with the session token). */
export function FileChips({ files }: { files: LmsFile[] }) {
  const { t } = useTranslation('lms')
  if (files.length === 0) return null
  return (
    <ul className="flex flex-wrap gap-2">
      {files.map((f) => (
        <li key={f.id}>
          <button
            type="button"
            onClick={() =>
              void downloadLmsFile(f.id).catch(() => toast.error(t('The file could not be downloaded')))
            }
            className="inline-flex max-w-72 items-center gap-2 rounded-control border border-line bg-surface px-2.5 py-1.5 text-left text-xs transition-colors hover:border-brand-300 hover:bg-brand-50/50"
            aria-label={t('Download {{name}}', { name: f.name })}
          >
            <FileText className="size-4 shrink-0 text-brand-600" aria-hidden="true" />
            <span className="min-w-0 truncate font-medium text-ink">{f.name}</span>
            <span className="shrink-0 text-muted">{formatBytes(f.size)}</span>
            <Download className="size-3.5 shrink-0 text-muted" aria-hidden="true" />
          </button>
        </li>
      ))}
    </ul>
  )
}
